import React, { Component, createContext } from 'react';
import { withRouter } from 'next/router';
import withLanguageContext from '../consumerHOC/LanguageConsumer';
import Cookie from 'js-cookie';

import { getData, api } from 'helpers';
import { updateState } from 'helpers/_getData';

const DataContext = createContext(null);
export const DataConsumer = DataContext.Consumer;

class DataProvider extends Component {
	state = { ...this.props.newData, prevRoute: null, hasBookmark: false };

	methods = {
		contact: this.contact.bind(this),
		formSection: this.formSection.bind(this),
		addFeedback: this.addFeedback.bind(this),
		enableLoading: this.enableLoading.bind(this),
		disableLoading: this.disableLoading.bind(this),
		addBookmark: this.addBookmark.bind(this),
		removeBookmark: this.removeBookmark.bind(this),
		checkIsBookmarked: this.checkIsBookmarked.bind(this),
		subscribe: this.subscribe.bind(this),
		loadMoreEvents: this.loadMoreEvents.bind(this),
		loadMoreArticles: this.loadMoreArticles.bind(this),
		loadMoreNewsRooms: this.loadMoreNewsRooms.bind(this),
	};

	componentDidMount() {
		this.updateBookmarkState();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const lang = this.props.router.locale || this.props.selectedLang;

		if (prevProps.router.asPath !== this.props.router.asPath || prevProps.router.locale !== this.props.router.locale) {
			this.updateBookmarkState();

			this.setState({ loading: true });
			getData({ lang, state: this.state, router: this.props.router }).then((res) => {
				this.setState({ ...res, loading: false, prevRoute: prevProps.router });
			});
		}
	}

	enableLoading() {
		this.setState({ loading: true });
	}

	disableLoading() {
		this.setState({ loading: false });
	}

	getBookmarks() {
		let existingBookmarks;

		try {
			existingBookmarks = Cookie.get('bookmarks');
			existingBookmarks = existingBookmarks ? JSON.parse(existingBookmarks) : [];
		} catch (error) {
			Cookie.remove('bookmarks');
		} finally {
			return existingBookmarks;
		}
	}

	addBookmark({ id, type }) {
		const newBookmark = { [type]: id };
		let existingBookmarks = this.getBookmarks();

		const isBookmarkExist = existingBookmarks.find((b) => JSON.stringify(b) === JSON.stringify(newBookmark));

		if (!isBookmarkExist) {
			Cookie.set('bookmarks', JSON.stringify([...existingBookmarks, newBookmark]));
		}

		this.updateBookmarkState();
	}

	removeBookmark({ id, type }) {
		const newBookmark = { [type]: id };
		let bookmarks = this.getBookmarks();

		const updatedBookmarks = bookmarks.filter((b) => JSON.stringify(b) !== JSON.stringify(newBookmark));

		if (!updatedBookmarks.length) {
			this.setState({ hasBookmark: false });
			Cookie.remove('bookmarks');
		} else {
			Cookie.set('bookmarks', JSON.stringify(updatedBookmarks));
		}
	}

	checkIsBookmarked({ id, type }) {
		const newBookmark = { [type]: id };
		const existingBookmarks = this.getBookmarks();

		return existingBookmarks.find((b) => JSON.stringify(b) === JSON.stringify(newBookmark));
	}

	updateBookmarkState() {
		this.setState({ hasBookmark: !!this.getBookmarks().length });
	}

	loadMoreEvents({ pageParams, queryParams }) {
		api.get('events', this.props.selectedLang, queryParams).then((res) => {
			const newState = updateState({
				lang: this.props.selectedLang,
				stateKey: 'events',
				response: {
					events: [...this.state.events[pageParams.queryName][this.props.selectedLang].events, ...res.events],
					hasMore: res.hasMore,
				},
				type: pageParams.queryName,
				state: this.state,
			});

			this.setState((prevState) => ({ ...prevState, ...newState }));
		});
	}

	loadMoreArticles({ pageParams, queryParams }) {
		api.get('articles', this.props.selectedLang, queryParams).then((res) => {
			const newState = updateState({
				lang: this.props.selectedLang,
				stateKey: 'articles',
				response: {
					articles: [...this.state.articles[pageParams.queryName][this.props.selectedLang].articles, ...res.articles],
					hasMore: res.hasMore,
				},
				type: pageParams.queryName,
				state: this.state,
			});

			this.setState((prevState) => ({ ...prevState, ...newState }));
		});
	}

	loadMoreNewsRooms({ pageParams, queryParams }) {
		api.get('news-rooms', this.props.selectedLang, queryParams).then((res) => {
			const newState = updateState({
				lang: this.props.selectedLang,
				stateKey: 'newsRooms',
				response: {
					newsRooms: [...this.state.newsRooms[pageParams.queryName][this.props.selectedLang].newsRooms, ...res.newsRooms],
					hasMore: res.hasMore,
				},
				type: pageParams.queryName,
				state: this.state,
			});

			this.setState((prevState) => ({ ...prevState, ...newState }));
		});
	}

	contact(data) {
		return api.post('contact-us', data);
	}

	subscribe(data) {
		return this.asyncFunctionDecorator(() => api.post('subscribe', data));
	}

	addFeedback(data) {
		return this.asyncFunctionDecorator(() => api.post('feedback', data));
	}

	formSection(data) {
		return this.asyncFunctionDecorator(() => api.post('form-section', data));
	}

	asyncFunctionDecorator = async (asyncFunc) => {
		return await asyncFunc().catch((err) => {
			return Promise.reject(err.response);
		});
	};

	render() {
		return <DataContext.Provider value={{ ...this.state, dataProviderState: this.state, ...this.methods }}>{this.props.children}</DataContext.Provider>;
	}
}

export default withRouter(withLanguageContext(DataProvider, ['selectedLang']));
